import { useEffect, useRef } from "react";

export const useClickOutside = (
  callback: () => void
): React.MutableRefObject<HTMLDivElement> => {
  let node = useRef<HTMLDivElement>(document.createElement("div"));

  useEffect(() => {
    let handler = (event: any) => {
      if (!node.current.contains(event.target)) callback();
    };

    document.addEventListener("mousedown", handler);

    return () => document.removeEventListener("mousedown", handler);
  });

  return node;
};

export default useClickOutside;
